import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {
    SimplePresentation, SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {LocalPresentation} from "../../../core/winpresentation/LocalPresentation";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {SuperFreespinIntro} from "../../runnerpresentations/superfreespin/SuperFreespinIntro";
import {ActivateSfsAnimations} from "../../runnerpresentations/superfreespin/ActivateSfsAnimations";


export class DevilsCrossroadSfsIdle implements FlowStatePresentation {

    constructor() {}

    start(flowStateController:FlowStateController):void {
        const presentations:SimplePresentation[] = [
            new SuperFreespinIntro(),
            new ActivateSfsAnimations(),
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.doFreeSpinZeroBet(controller), ()=>{return true}, "doFreeSpinZeroBet")
        ];

        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "Sfs intro runner ");

    }

    private doFreeSpinZeroBet(controller:SimplePresentationRunnerController) {
        DevilsCrossRoad.apiPlugin.betHandler.zeroBet();
        DevilsCrossRoad.keypadPlugin.setZeroBetSpinCounter(DevilsCrossRoad.model.data.freespinsLeft-1);
        DevilsCrossRoad.freespinUnlockAreas.setIndicator(DevilsCrossRoad.model.data.freespinsLeft-1);
        DevilsCrossRoad.freespinUnlockAreas.resetSpinsFullCounter();
        controller.finish();
    }

}